export default "__VITE_ASSET__CPVO$c78__"